import { useMemo, useRef, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  languageChange,
  currentSelectedLanguage,
  setSettingFor,
  setDefaultSettingsFor
} from "../../../../StateManagement/actions";
import WarnUnSaveChangesPopUp from "../../../Shared/UnSaveChangesWarnPopUp/WarnUnSaveChangesPopUp";
import useValidateSettings from "../hooks/useValidateSettings";
import { useFetchLookupData } from '../hooks/useFetchLookupData'


export default function HeaderTab({ role, onSubmit, activeHeaderIndex,reRender }) {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const tabLinks = useRef([]);
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const dispatch = useDispatch();
  const settings = useSelector(state => state.settings);




  const { showConfirmationPopup, validateSettings } = useValidateSettings();


  const handleTabClick = (e, index) => {
    e.preventDefault();
    dispatch(
      setDefaultSettingsFor({
        value: 'Gateway',
      })
    )
    const result = showConfirmationPopup(settings);
    if (result) {
      if (role === 'User' && index === 0) {
        return;
      }
      onSubmit(index);
    } else {
      setActiveTabIndex(index);
      if(role === "User"){
        dispatch(setSettingFor('User'));
      }else{
        let settingValue = index === 0 ? 'Company' : index === 1 ? 'User' : 'Admin';
        dispatch(setSettingFor(settingValue));
      }
    }
  };

  const { fetchLookupData } = useFetchLookupData();

  useEffect(() => {
    if (tabLinks.current[0]) {
      tabLinks.current[0].classList.add('active');
      dispatch(setSettingFor(role === 'User' ? 'User' : 'Company'));
      fetchLookupData();
    }
  }, []);

  useEffect(() => {
    setActiveTabIndex(activeHeaderIndex);
  }, [activeHeaderIndex,reRender]);




  const headerTabs = useMemo(() => {
    return [
      {
        role: "Company",
        displayText: selectedLanguage.LstLanguageCodes.UI_Company,
        icon: "business",
      },
      {
        role: "User",
        displayText: selectedLanguage.LstLanguageCodes.UI_Personal,
        icon: "settings_accessibility",
      },
      {
        role: "Admin",
        displayText: selectedLanguage.LstLanguageCodes.UI_Admin,
        icon: "admin_panel_settings",
      },
    ];
  }, []);




  return (
    <>

      {headerTabs
        .filter((tab) => role === 'Admin' || tab.role === role)
        .map((tabContent, index) => {
          return (
            <li key={index} className="nav-item" role="presentation">
              <a
                id={`ex2-tab-${index + 1}`}
                className={`nav-link d-flex align-items-center manage-link admintab ${activeTabIndex === index ? 'active' : ''}`}
                data-bs-toggle="tab"
                href={`#ex2-tabs-${index + 1}`}
                role="tab"
                ref={el => tabLinks.current[index] = el}
                onMouseDown={(e) => handleTabClick(e, index)}
              // aria-controls={`ex2-tabs-${index + 1}`}
              // aria-selected={activeTabIndex === index}
              >
                <span className="material-icons me-1 font-22p">
                  {tabContent.icon}
                </span>
                {tabContent.displayText}
              </a>
            </li>
          );
        })}

    </>
  );
}
